import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2f48662c&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=2f48662c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48662c",
  null
  
)

component.options.__file = "App.vue"
export default component.exports